import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { reports_action } from "../../../Redux/Actions/reports_action"
import FileDownload from "js-file-download";
import ReactPaginate from "react-paginate";
import moment from "moment";
import * as XLSX from "xlsx";
import { Link } from 'react-router-dom';
function ReportAttendanceCom() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const [comdata, setComdata] = useState([]);
    const [company, setCompany] = useState('');
    const [empId, setEmpId] = useState(token.userId);
    const [dept, setDept] = useState([]);
    const [deptid, setDeptid] = useState('');
    const [user, setUser] = useState([]);
    const [reporterUser, setReporterUser] = useState('');
    const pagination = useRef();
    const dispatch = useDispatch()
    const state = {
        comp_id: company,
        dept_id: deptid,
        user_id: reporterUser,
        perPage: 10,
        paheNo: 1
    }

    const report_user_state = useSelector(state => state)
    useEffect(() => {
        dispatch(reports_action(state))
    }, [])

    const setPage = ({ selected }) => {
        const state = {
            comp_id: company,
            dept_id: deptid,
            user_id: reporterUser,
            perPage: 10,
            paheNo: selected + 1
        }
        dispatch(reports_action(state))
    }
    const getCompanyList = () => {
        const response = fetch(SERVER_URL + `api/common/company_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },

            }).then(res => res.json())
            .then(data => {
                setComdata(data.result)
            });
    }
    const getDepartment = async () => {

        const response = await fetch(SERVER_URL + `api/common/department_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
            .then(data => {
                setDept(data.result)
            })
    }
    useEffect(() => {
        getCompanyList()
        getDepartment()
    }, [])

    useEffect(() => {
        getUserByDept_Or_ManagerId()
    }, [deptid])


    const getUserByDept_Or_ManagerId = () => {
        const response = fetch(SERVER_URL + `api/reports/getusers_under_manager_or_deptId`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    empId: empId,
                    deptId: deptid
                }),
            }).then(res => res.json())
            .then(data => {
                setUser(data.results)
            })
    }

    const SearchFilter = () => {
        dispatch(reports_action(state))
    }

    const [products, setProducts] = useState([])
    // const products = [
    //     {
    //         "id": 1,
    //         "title": "Fjallraven - Foldsack No. 1 Backpack, Fits 15 Laptops",
    //         "category": "men's clothing",
    //     },
    //     {
    //         "id": 1,
    //         "title": "Fjallraven - Foldsack No. 1 Backpack, Fits 15 Laptops",
    //         "category": "men's clothing",
    //     }
    // ]
    const DownloadExelReport = () => {
        getUserReports()
      
    }


    const getUserReports = () => {
        const response = fetch(SERVER_URL + `api/reports/getUserReport`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    state: state
                }),
            }).then(res => res.json())
            .then(data => {
                download_report(data.results)
            })
    }
    Number.prototype.before = function () {
        var value = parseInt(this.toString().split(".")[0], 10);
        return value ? value : 0;
      }
    const download_report = (reportdata) => {

        const rows = reportdata?.map((product) => ({                    
            Name: product.fname+`${product.mname?' '+product.mname:''}${product.lname?' '+product.lname:''}`,
            Date: moment(product.att_date).format('DD MMM, yyyy'),       
            Start_Time: product.start_time,
            End_Time : product.enttime ,
            TOTALHRS: product?.TOTALHRS?product.TOTALHRS.before()/60:'', 
        }));

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(rows);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
        XLSX.utils.sheet_add_aoa(worksheet, [
            [],
        ]);

        XLSX.writeFile(workbook, "ReportFor2023.xlsx", { compression: true });
    }
    return (
        <>
            <div className="page-header">
                <h1>
                    Reports
                </h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                    <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> Reports
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="dash_white_box2 mb20 p20">
                    <div className="dash_white_box_ttl">Search</div>
                    <div className="row mb10">
                        <div className="col-lg-3 col-md-6 pl07 pr07">
                            <div className="form-blk mb15">
                                <label className="form-label">Company</label>
                                <div className="form-input">
                                    <select value={company} onChange={(e) => setCompany(e.target.value)} className="form-select">
                                        <option value=''>Select Company</option>
                                        {
                                            comdata?.map((item, ind) => (
                                                <option key={ind} value={item.id}>{item.name}</option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 pl07 pr07">
                            <div className="form-blk mb15">
                                <label className="form-label">Department</label>
                                <div className="form-input">
                                    <select value={deptid} onChange={(e) => setDeptid(e.target.value)} className="form-select">
                                        <option value=''>Select Department </option>
                                        {
                                            dept?.map((item, ind) => {
                                                return <option key={ind + 1} value={item.id}>{item.name}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 pl07 pr07">
                            <div className="form-blk mb15">
                                <label className="form-label">User </label>
                                <div className="form-input">
                                    <select value={reporterUser} onChange={e => setReporterUser(e.target.value)} className="form-select">
                                        <option value=''>Select User  </option>
                                        {
                                            user?.map((item, ind) => {
                                                return <option value={item.id}>{item.fname}{item.mname ? ` ${item.mname}` : ''}{item.lname ? ` ${item.lname}` : ''}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>



                        <div className="col-lg-3 col-md-6 pr07">
                            <label className="h49 mb10"></label>
                            <button onClick={SearchFilter} className="btn_5">Search</button>
                        </div>
                    </div>
                </div>
                <div className="row mb30">
                    <div className="col-md-12">
                        <button onClick={(e) => DownloadExelReport(e)} className="btn_5 mb10 float-end">Download Reports</button>
                        <table className="table_style_1">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>Employee Name</th>
                                    <th>Department </th>
                                    <th>Designation	</th>
                                    <th>Employee Code</th>
                                    <th>Employee Type</th>
                                    <th>Contact</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    report_user_state?.report_user?.users?.map((item, ind) => {
                                        return <tr key={ind}>
                                            <td>
                                                {ind + 1}
                                            </td>
                                            <td>
                                                {item?.fname ? item?.fname : ''}
                                                {item?.mname ? `${' ' + item?.mname}` : ''}
                                                {item?.lname ? `${' ' + item?.lname}` : ''}
                                            </td>
                                            <td>{item.role_name}</td>
                                            <td>{item.dept_name}</td>
                                            <td>{item.user_code}</td>
                                            <td>-</td>
                                            <td>{item.contact_no}</td>
                                            <td><button className="btn_5 mr03">View</button></td>
                                        </tr>
                                    })
                                }

                            </tbody>
                            <tfoot>
                                <tr><td colSpan="8" >
                                    <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                                    <ReactPaginate
                                        ref={pagination}
                                        pageCount={Math.ceil(report_user_state?.report_user?.Total / state.perPage)}
                                        pageRangeDisplayed={4}
                                        marginPagesDisplayed={1}
                                        onPageChange={setPage}
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        pageLinkClassName="page-link"
                                        breakLinkClassName="page-link"
                                        nextLinkClassName="page-link"
                                        previousLinkClassName="page-link"
                                        pageClassName="page-item"
                                        breakClassName="page-item"
                                        nextClassName="page-item"
                                        previousClassName="page-item"
                                        previousLabel={<>&laquo;</>}
                                        nextLabel={<>&raquo;</>}
                                    />
                                </td></tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReportAttendanceCom
